import React from "react";
import "./aboutUs.css";
import { RiSecurePaymentFill } from "react-icons/ri";
import { MdContactless, MdFingerprint } from "react-icons/md";
import Button from "../Styled/Button";

const AboutUs = () => {
  return (
    <div className="containerAboutUs" id="aboutUs">
      <div className="container-title">
        <h1>Why choose Ethicalottery?</h1>
        <div className="spiegazione-aboutUs">
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Impedit,
            repellat mollitia?
          </p>
        </div>
      </div>
      <div className="container_information">
        <div className="container-information" data-aos="fade-up" data-aos-delay="300">
          <RiSecurePaymentFill className="iconAbout" />
          <h3>Fully secured</h3>
        </div>
        <div className="container-information" data-aos="fade-up" data-aos-delay="900">
          <MdContactless className="iconAbout" />
          <h3>Always connected</h3>
        </div>
        <div className="container-information" data-aos="fade-up" data-aos-delay="1200">
          <MdFingerprint className="iconAbout" />
          <h3>Fully decentralized</h3>
        </div>
      </div>
      <div className="btn-aboutUs">
        <Button>PLAY NOW</Button>
      </div>
      
    </div>
  );
};

export default AboutUs;
